import {
  getShipmentInfoFromStops,
  stopRenderer,
  warningRenderer,
  getJourneyPallets,
  convertCMtoMeters,
} from '../utils';

const FR_Assignation_template = (journey) => {
  const { stops, extras, item_height, id, net_full_cost, max_weight } = journey;

  const country = 'FR';
  const totalPallets = getJourneyPallets(journey, country);
  const stopsInfo = getShipmentInfoFromStops(stops, country);
  const stopsToRender = stopRenderer(stops, country).join('');
  const warning = warningRenderer(extras, country);
  const totalHeight = convertCMtoMeters(item_height);

  return `
    The job is yours
    Reference Number: ${id}

    ${totalPallets}
    ${totalHeight}m - Total Height
    ${max_weight} Kg - Maximum Weight

    ${stopsInfo.shipmentType}
    ${stopsInfo.PICKUP} Collection(s), ${stopsInfo.DROPOFF} Drop off(s)
    ${stopsToRender}
    ${warning}

    Amount you earn: £ ${net_full_cost} VAT not inc.
    `;
};

export default FR_Assignation_template;
